import { Flex, Box, Tooltip, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Input, Textarea, Select } from "@chakra-ui/react";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import apiUrl from "variables/api";

export default function Mark({ mark, color, addedBy, comment, markId, fetchMarksData, disabled }) {
  const colorMap = {
    1: "red.500",
    2: "green.500",
    3: "purple.500",
    4: "yellow.500",
    5: "blue.500",
  };

  color = colorMap[color] || "red.500";
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editedMark, setEditedMark] = useState(mark);
  const [editedComment, setEditedComment] = useState(comment);
  const [editedColor, setEditedColor] = useState(Object.keys(colorMap).find(key => colorMap[key] === color));

  const handleSave = () => {
    if (!editedMark) {
      toast.error("Ocena nie może być pusta");
      return;
    }
    if(editedMark < 0 || editedMark > 6) {
      toast.error("Ocena musi być z przedziału od 0 do 6");
      return;
    }
    if(editedComment.length > 255) {
      toast.error("Komentarz nie może być dłuższy niż 255 znaków");
      return;
    }
    if(editedComment.length < 3) {
      toast.error("Komentarz musi zawierać przynajmniej 3 znaki");
      return
    }
    if(!editedColor) {
      toast.error("Kolor nie może być pusty");
      return;
    }
    
    const updatedMark = {
      mark: editedMark,
      comment: editedComment,
      color: editedColor,
    };

    axios
      .put(`${apiUrl}/data/school/company/marks/update/${markId}`, updatedMark, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        toast.success("Pomyślnie zaktualizowano ocenę");
        fetchMarksData();
        onClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas aktualizacji oceny");
      });
  };

  return (
    <>
      <Tooltip
        label={
          <>
            Ocena: {mark}
            <br />
            Dodana przez: {addedBy}
            <br />
            Komentarz: {comment}
          </>
        }
        hasArrow
        placement="top"
        isDisabled={!comment || disabled}
      >
        <Button
          bg={color || "red.500"}
          size="sm"
          color="white"
          p={2}
          disabled={disabled}
          display="inline-block"
          borderRadius="md"
          textAlign="center"
          userSelect="none"
          onClick={() => {
            if((addedBy === localStorage.getItem("nickname") || localStorage.getItem("roles").includes("973337145844584538") ||
            localStorage.getItem("roles").includes("973342432446009344") ||
            localStorage.getItem("roles").includes("973342432659914823") ||
            localStorage.getItem("roles").includes("1190995987154616381")) && addedBy && comment && !disabled) {
              onOpen();
            }
          }}
        >
          <p>{mark}</p>
        </Button>
      </Tooltip>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edytuj ocenę</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Ocena"
              value={editedMark}
              onChange={(e) => setEditedMark(e.target.value)}
              mb={3}
            />
            <Textarea
              placeholder="Komentarz"
              value={editedComment}
              onChange={(e) => setEditedComment(e.target.value)}
              mb={3}
            />
            <Select
              placeholder="Wybierz kolor"
              value={editedColor}
              onChange={(e) => setEditedColor(e.target.value)}
            >
              <option value="1">Czerwony</option>
              <option value="2">Zielony</option>
              <option value="3">Fioletowy</option>
              <option value="4">Żółty</option>
              <option value="5">Niebieski</option>
            </Select>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="space-between" w="100%">
              
          <Button disabled={!(localStorage.getItem("roles").includes("973337145844584538") ||
            localStorage.getItem("roles").includes("973342432446009344") ||
            localStorage.getItem("roles").includes("973342432659914823") ||
            localStorage.getItem("roles").includes("1190995987154616381"))} colorScheme="red" mr={3} onClick={() => {
            axios
              .delete(`${apiUrl}/data/school/company/marks/${markId}`, {
                headers: { "x-access-token": localStorage.getItem("token") },
              })
              .then((response) => {
                toast.success("Pomyślnie usunięto ocenę");
                fetchMarksData();
                onClose();
              })
              .catch((error) => {
                console.error(error);
                toast.error("Napotkano błąd podczas usuwania oceny");
              });
          }}>
              Usuń ocenę
            </Button>
            <Flex>
            <Button colorScheme="red" mr={3} onClick={onClose}>
              Anuluj
            </Button>
            <Button colorScheme="green" onClick={handleSave}>
              Zapisz
            </Button>
            </Flex>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}